import { Outlet } from "react-router";
import CommonHero from "../layout/common/commonHero";
import Navbar from "../layout/homePage/navbar/navbar";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";
import BlogsList from "../layout/blogs/list/BlogsList";

export default function Blogs() {
   return (

     <>
    <Navbar />
    <CommonHero />
    <BlogsList />
    <Outlet />
    <HomePageFooter />
  </>

  );
}